const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速秒播',
    desc: '分布式CDN加速节点覆盖全国，智能选择最优线路，点击即播无需等待，深夜高峰时段同样流畅如丝。',
    bgClass: 'bg-primary-50',
    iconClass: 'text-primary-600',
  },
  {
    icon: 'ri-stack-fill',
    title: '海量片库',
    desc: '20000+ 高清影视资源持续增长，涵盖动作、悬疑、喜剧、科幻、爱情、纪录等全类型，每日凌晨自动更新最新剧集。',
    bgClass: 'bg-accent-50',
    iconClass: 'text-accent-600',
  },
  {
    icon: 'ri-moon-clear-fill',
    title: '凌晨更新',
    desc: '专为夜猫子定制的更新节奏，每日凌晨 2:00 准时上架最新剧集和电影，让你第一时间追到新鲜热乎的好内容。',
    bgClass: 'bg-secondary-100',
    iconClass: 'text-secondary-600',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '手机、平板、电脑无缝切换，躺床上用手机刷剧、坐桌前用电脑看大片，观影进度自动同步，随时随地继续追。',
    bgClass: 'bg-primary-50',
    iconClass: 'text-primary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            观影优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            为什么夜猫子们都选择在这里熬夜追剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer text-center"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl ${feat.bgClass} transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${feat.icon} text-2xl md:text-3xl ${feat.iconClass}`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}